module.exports = __webpack_public_path__ + "assets/img/ru-eba53d56.png";